import { LocationType } from 'app/shared/features/location-selector/models/location-type';
import { MeasurementType } from 'app/shared/models/measurement-type';
import { ResultDeterminationType } from 'app/shared/models/result-determination-type';

import { ActivityType } from './activity-type';

export const defaultActivity = (): Activity => {
    return {
        name: '',
        number: 0,
        activityType: ActivityType.Generic,
        defaultProductBoxNumber: undefined,
        orderedProductBoxNumbers: [],
        isBatchInputRequired: false,
        locationType: null,
        nrOfDecimalsBeforeDecimalPoint: 0,
        nrOfDecimalsAfterDecimalPoint: 0,
        presentationUnit: '',
        registrationUnit: '',
        resultDeterminationType: ResultDeterminationType.noResult,
        measurementType: MeasurementType.noMeasurementType,
        measurementUnit: '',
        measurementUnitNrOfDecimalsAfterDecimalPoint: 0,
        measurementUnitNrOfDecimalsBeforeDecimalPoint: 0,
    };
};

export interface Activity {
    name: string;
    number: number;
    activityType: ActivityType;
    defaultProductBoxNumber: number | undefined;
    orderedProductBoxNumbers: number[];
    isBatchInputRequired: boolean;
    locationType: LocationType | null;
    nrOfDecimalsAfterDecimalPoint: number;
    nrOfDecimalsBeforeDecimalPoint: number;
    presentationUnit: string;
    registrationUnit: string | undefined;
    resultDeterminationType: ResultDeterminationType;
    measurementType: MeasurementType;
    measurementUnit: string;
    measurementUnitNrOfDecimalsAfterDecimalPoint: number;
    measurementUnitNrOfDecimalsBeforeDecimalPoint: number;
}

export const dividerActivityNumber = -9999;

export const createActivityDivider = (label?: string): Activity => {
    return {
        ...defaultActivity(),
        number: dividerActivityNumber,
        name: label ? label : '',
    };
};

export const isActivityDivider = (activity: Activity): boolean => {
    return activity.number === dividerActivityNumber;
};
